import { render, staticRenderFns } from "./PlatStaff.vue?vue&type=template&id=082c5056&scoped=true"
import script from "./PlatStaff.vue?vue&type=script&lang=js"
export * from "./PlatStaff.vue?vue&type=script&lang=js"
import style0 from "./PlatStaff.vue?vue&type=style&index=0&id=082c5056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082c5056",
  null
  
)

export default component.exports